import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import FatalTopLevelError from './FatalTopLevelError';
import { jsx as _jsx } from "react/jsx-runtime";
const TopLevelErrorBoundary = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "Application",
    renderError: FatalTopLevelError,
    children: children
  });
};
export default TopLevelErrorBoundary;
TopLevelErrorBoundary.displayName = 'TopLevelErrorBoundary';